import {useCallback, useState} from 'react';

export default function useFormState(defaultValues) {
  const [formData, _setFormData] = useState(defaultValues || {});

  const setFormData = useCallback((updatedValues) => {
    _setFormData({
      ...formData,
      ...updatedValues
    })
  }, [formData, _setFormData]);

  return [formData, setFormData];
}
